import { BuiltinType } from './types';
export class BuiltinInstanceMemberCall {
    constructor() {
        this.types = new Set([BuiltinType.InstanceMemberCall]);
    }
}

//# sourceMappingURL=BuiltinInstanceMemberCall.js.map
